import '../../scripts/common';

import '../../scripts/autosize';
import 'animate.css/animate.css';
import '../../scripts/animate';
import '../../scripts/picture';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Carousel from '../../components/base/Carousel';
import HomepageSlide from '../../components/HomepageSlide';
import Popup from '../../components/base/Popup';
import Promotion from '../../components/Promotion';
import Tabs from '../../components/base/Tabs';
import ProductCard from '../../components/ProductCard';
import ProductsList from '../../components/ProductsList';
import ArticlesList from '../../components/ArticlesList';
import LinksList from '../../components/LinksList';
import ArticleCard from '../../components/ArticleCard';
import ProductTypesList from '../../components/ProductTypesList';
import ProductQuickView from '../../components/ProductQuickView';
import Stock from '../../components/Stock';
import PageScrollBtn from '../../components/simple/PageScrollBtn';
import Field from '../../components/base/Field';

import { media } from '../../scripts/helpers';
import breakpoints from '../../scripts/variables';
import './styles.css';

import '../../images/sprite/cross.svg';
import '../../images/sprite/klorane_logo.svg';
import '../../images/sprite/galenic_logo.svg';
import '../../images/sprite/elancyl_logo.svg';
import '../../images/sprite/eauthermaleavene_logo.svg';
import '../../images/sprite/ducray_logo.svg';
import '../../images/sprite/a-derma_logo.svg';

$(() => {
    Field.create();
    Header.create();
    Footer.create();
    Promotion.create();
    initStock();
    initCarousel();
    initHomepageSlide();
    initTabs();
    initProductCard();
    ProductsList.create();
    ArticlesList.create();
    LinksList.create();
    ProductTypesList.create();
    PageScrollBtn.create();
    initArticleCard();
    initPopup();
});

function initCarousel() {
    const carouselHomepageObj = new Carousel($('.carousel--homepage'));
    carouselHomepageObj.init(
        {},
        {
            loop: false,
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            slidesPerView: 1,
        }
    );

    const productsSlidesCount = $('.swiper-slide', $('.carousel--products')).length;

    const carouselProductsObj = new Carousel($('.carousel--products'));
    carouselProductsObj.init(
        {
            reinitBreakpoints: [media('tabletLg')],
            reinitOptions: {
                default: {
                    loop: productsSlidesCount > 4,
                },
                [breakpoints.mobileLg - 1]: {
                    loop: productsSlidesCount > 2,
                },
                [breakpoints.tabletLg - 1]: {
                    loop: productsSlidesCount > 3,
                },
            },
        },
        {
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            slidesPerView: 4,
            loop: productsSlidesCount > 4,
            slideToClickedSlide: false,
            breakpoints: {
                [breakpoints.mobileLg - 1]: {
                    slidesPerView: 2,
                },
                [breakpoints.tabletLg - 1]: {
                    slidesPerView: 3,
                },
            },
        }
    );

    const productsNewSlidesCount = $('.swiper-slide', $('.carousel--products-new')).length;

    const carouselProductsNewObj = new Carousel($('.carousel--products-new'));
    carouselProductsNewObj.init(
        {
            reinitBreakpoints: [media('tabletLg')],
            reinitOptions: {
                default: {
                    loop: productsSlidesCount > 4,
                },
                [breakpoints.mobileLg - 1]: {
                    loop: productsSlidesCount > 2,
                },
                [breakpoints.tabletLg - 1]: {
                    loop: productsSlidesCount > 3,
                },
            },
        },
        {
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            slidesPerView: 4,
            loop: productsNewSlidesCount > 4,
            slideToClickedSlide: false,
            breakpoints: {
                [breakpoints.mobileLg - 1]: {
                    slidesPerView: 2,
                },
                [breakpoints.tabletLg - 1]: {
                    slidesPerView: 3,
                },
            },
        }
    );

    const newSlidesCount = $('.swiper-slide', $('.carousel--new')).length;

    const carouselNewObj = new Carousel($('.carousel--new'));
    carouselNewObj.init(
        {
            reinitBreakpoints: [media('tabletLg')],
            reinitOptions: {
                default: {
                    loop: newSlidesCount > 3,
                },
                [breakpoints.tabletLg - 1]: {
                    loop: newSlidesCount > 2,
                },
            },
        },
        {
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            slidesPerView: 3,
            loop: newSlidesCount > 3,
            slideToClickedSlide: false,
            breakpoints: {
                [breakpoints.tabletLg - 1]: {
                    slidesPerView: 2,
                },
                [breakpoints.tablet - 1]: {
                    slidesPerView: 1,
                },
            },
        }
    );
}

/**
 * Инициализация слайдов
 */
function initHomepageSlide() {
    $('.homepage-slide').each((i, item) => {
        const homepageSlide = new HomepageSlide($(item));
        homepageSlide.init({});
    });
}

/**
 * Табы
 */
function initTabs() {
    const tabsBrandHistory = new Tabs($('.tabs--brand-history'));
    tabsBrandHistory.init({
        selected: 0,
    });

    Tabs.create();
}

/**
 * Инициализация карточек товара
 */
function initProductCard() {
    $('.product-card').each((i, item) => {
        const productDefault = new ProductCard($(item));
        productDefault.init({});
    });

    ProductQuickView.create();
}

/**
 * Инициализация баннера
 */
function initStock() {
    $('.stock').each((i, item) => {
        const stockDefault = new Stock($(item));
        stockDefault.init({});
    });
}

/**
 * Инициализация карточек статей
 */
function initArticleCard() {
    $('.article-card').each((i, item) => {
        const articleDefault = new ArticleCard($(item));
        articleDefault.init({});
    });
}

/**
 * Активация попапов
 */
function initPopup() {
    Popup.create();
}
